var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 19,
    viewBox: "0 0 21 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.4995 14.05C10.6585 14.05 10.8175 14.088 10.9625 14.163L14.7315 16.133L14.0145 11.976C13.9575 11.65 14.0665 11.318 14.3045 11.087L17.3405 8.151L13.1375 7.539C12.8125 7.492 12.5315 7.289 12.3855 6.995L10.4995 3.201L8.61355 6.995C8.46755 7.289 8.18655 7.492 7.86155 7.539L3.65855 8.151L6.69455 11.087C6.93255 11.318 7.04155 11.65 6.98455 11.976L6.26755 16.133L10.0365 14.163C10.1815 14.088 10.3405 14.05 10.4995 14.05ZM16.0615 18.955C15.9025 18.955 15.7435 18.918 15.5985 18.842L10.4995 16.178L5.40055 18.842C5.06255 19.018 4.65455 18.987 4.34955 18.763C4.04155 18.539 3.88855 18.16 3.95255 17.785L4.92455 12.157L0.804547 8.172C0.529547 7.907 0.431547 7.509 0.548547 7.146C0.664547 6.783 0.978547 6.519 1.35555 6.464L7.05655 5.636L9.60355 0.51C9.94155 -0.17 11.0575 -0.17 11.3955 0.51L13.9425 5.636L19.6435 6.464C20.0205 6.519 20.3345 6.783 20.4505 7.146C20.5675 7.509 20.4695 7.907 20.1945 8.172L16.0745 12.157L17.0465 17.785C17.1105 18.16 16.9575 18.539 16.6495 18.763C16.4765 18.891 16.2695 18.955 16.0615 18.955Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/Star.2383ceddb07a46e3360ac9ff099adbee.svg";
export { ForwardRef as ReactComponent };